import { Dispatch, SetStateAction } from "react";

import {
  subDays,
  isBefore,
  isValid,
  parseISO,
  subMonths,
  addMonths,
  differenceInMonths
} from 'date-fns';

import { DateOutputStr } from 'utils/DateOutput';
import { Period } from "./interface";
import { HolidayProps } from "pages/DeliveryScheduling/interface";
import toast from "components/Toast/dispatch";

export const IsInLimitDate = (date: string, limit: number): boolean => {
  if (!date) return false;
  const dateObj = parseISO(date);

  if (!isValid(dateObj)) return false;

  const limitDate = subDays(new Date(), limit + 1);

  return !isBefore(dateObj, limitDate);
};

export const IsInLimitMonth = (date: string, limit: number): boolean => {
  if (typeof date !== 'string') {
    return false;
  }

  let dateObj;
  try {
    dateObj = parseISO(date);
  } catch (error) {
    console.error('Erro ao analisar a data:', error);
    return false;
  }

  if (!isValid(dateObj)) return false;

  const limitDate = subMonths(new Date(), limit);

  return !isBefore(dateObj, limitDate);
};


export const calcDataTo = (period: Period, newDate: string, setPeriod: Dispatch<SetStateAction<Period>>, month = 3) => {
  const intervalInMonth = Math.abs(differenceInMonths(new Date(period.from), new Date(period.to))) + 1;

  if (intervalInMonth > month && newDate === 'end') {
    const endDate = addMonths(new Date(period.from), month);
    const compareDate = isBefore(endDate, new Date());

    if (compareDate) {
      setPeriod({ ...period, to: DateOutputStr(endDate.toISOString(), 'yyyy-MM-dd') });
    } else {
      setPeriod({ ...period, to: DateOutputStr(new Date().toISOString(), 'yyyy-MM-dd') });
    }
  }
};

export const calcDataFrom = (period: Period, newDate: string, setPeriod: Dispatch<SetStateAction<Period>>, month = 3) => {
  const intervalInMonth = Math.abs(differenceInMonths(new Date(period.from), new Date(period.to))) + 1;

  if (intervalInMonth > month && newDate === 'start') {
    const startDate = subMonths(new Date(period.to), month);

    setPeriod({ ...period, from: DateOutputStr(startDate.toISOString(), 'yyyy-MM-dd') });
  }
};

export const limitDateTo = (period: Period, toDate: string, setPeriod: Dispatch<SetStateAction<Period>>) => {
  const endDate = new Date(toDate).getFullYear();
  const limitYears = 9999;

  if (endDate > limitYears) return;

  setPeriod({ ...period, to: toDate });
};

export const concatDateAndTimeFormatToISODate = (date: string, time: string) => {
  const dateFormat = date.replace(/\//g, '-');
  return `${dateFormat}T${time}:00.000Z`;
};

export const checkIfIsWeekend = (date: Date) => {
  return (!(date.getDay() % 6)) ? true : false;
};

export const addDaysNewDate = (day: string | Date, qtdDay: number) => {
  const newDate: Date = new Date(day);
  newDate.setDate(newDate.getDate() + qtdDay);

  return newDate;
};

export const checkIfIsHoliday = (date: Date, holidaysArray: HolidayProps[]) => {
  if (holidaysArray && holidaysArray?.find((holiday) =>
    new Date(holiday.date).toLocaleDateString() === date.toLocaleDateString())
  ) return true;
};

export const getMinDateInSearchFilter = (month = 3) => {
  const minDate = new Date();
  minDate.setMonth(minDate.getMonth() - month);
  minDate.setDate(minDate.getDate() + 1);

  return minDate;
};

export const getMaxDateInSearchFilter = () => {
  return new Date(new Date().toDateString());
};

export const formatDateToISO_UTC = (date: Date): Date => {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
};

export const validateDatePeriodExportData = (startPeriod?: string | Date, lastPeriod?: string | Date) => {
  if (!lastPeriod || !startPeriod) return;

  const startPeriodFilterExport = new Date(startPeriod);
  const lastPeriodFilterExport = new Date(lastPeriod);

  const diffInMonth = differenceInMonths(lastPeriodFilterExport, startPeriodFilterExport);
  return validateDatePeriod(diffInMonth, true, false);
};

export const validateDatePeriod = (diffInMonth: number, ArraysEqualAll: boolean, ArraysEqualDelivered: boolean): boolean => {

  const diffInMonthCorrect = diffInMonth + 1;

  if (ArraysEqualAll || ArraysEqualDelivered) {
    if (diffInMonthCorrect > 1) {
      toast.info("Atenção", "Para exportar os dados, é necessário restringir o período dentro de um intervalo de 30 dias. Por favor, verifique o intervalo das datas.");
      return false;
    }
  }

  if (diffInMonthCorrect > 3) {
    toast.info("Atenção", "Para exportar os dados, é necessário restringir o período dentro de um intervalo de 3 meses. Por favor, verifique o intervalo das datas.");
    return false;
  }

  return true;
};

export const validateDatePeriodFollowUp = (diffInMonth: number, maxQuantity: number): boolean => {

  const diffInMonthCorrect = diffInMonth + 1;

  if (diffInMonthCorrect > 1 && maxQuantity === 1) {
    toast.info("Atenção", "Para exportar os dados, é necessário restringir o período dentro de um intervalo de 30 dias. Por favor, verifique o intervalo das datas.");
    return false;
  }

  if (maxQuantity > 1 && diffInMonthCorrect > maxQuantity) {
    toast.info("Atenção", `Para exportar os dados, é necessário restringir o período dentro de um intervalo de ${maxQuantity} meses. Por favor, verifique o intervalo das datas.`);
    return false;
  }

  return true;
};
